<div class="names-tooltip">
  @for (name of names(); track name) {
    <div class="name-row">
      <!-- <span class="dot"></span> -->
      <span class="name text-type-nine">{{ name }}</span>
    </div>
  }
  <div class="arrow"></div>
</div>
